import { render, staticRenderFns } from "./main.vue?vue&type=template&id=2748425b&scoped=true&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"
import style0 from "./main.vue?vue&type=style&index=0&id=2748425b&lang=scss&"
import style1 from "./main.vue?vue&type=style&index=1&id=2748425b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2748425b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2748425b')) {
      api.createRecord('2748425b', component.options)
    } else {
      api.reload('2748425b', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=2748425b&scoped=true&", function () {
      api.rerender('2748425b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/template/main.vue"
export default component.exports